import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { Modal, Spin } from 'antd'
import CheckoutForm from '../../elements/Payment/CheckoutForm'
import Success from '../../elements/Payment/Success'
import React, { useState } from 'react'

function PaymentCont(props) {
  const { visible, onCancel, currency, description, amount, postURL, payload, companyID } = props

  const [leadingKey, setLeadingKey] = useState(false)

  // const stripePromise = loadStripe('pk_live_MgrsdFY1mjvqUUmi1e5FgnPl00JXz9Sgxf')
  const stripePromise = loadStripe('pk_live_MgrsdFY1mjvqUUmi1e5FgnPl00JXz9Sgxf')
  const [succeeded, setSucceeded] = useState(false)

  return (
    <Modal
      title="Payment"
      visible={visible}
      // visible={true}
      onCancel={onCancel}
      width={'60%'}
      footer={null}>
      <Spin spinning={leadingKey}>
        <Elements stripe={stripePromise}>
          {succeeded ? (
            <Success data={succeeded} onCancel={onCancel} />
          ) : (
            <CheckoutForm
              {...{
                onCancel,
                setSucceeded,
                currency,
                description,
                amount,
                postURL,
                payload,
              }}
            />
          )}
        </Elements>
      </Spin>
    </Modal>
  )
}

export default PaymentCont
